import Bugsnag from '@bugsnag/js';

export default function errorLogger({ error = null, consoleMessage = null }) {
  if (error) {
    Bugsnag.notify(error);
  }

  if (consoleMessage) {
    console.error(consoleMessage);
  }
}
